module.exports = __webpack_public_path__ + "img/shengtai.428bf8aa.svg";